/* Imports needed for all question form subclasses. */
import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import {
    mapStateToQuestionFormBaseProps,
    mapDispatchToQuestionFormBaseProps
} from '../../QuestionFormBase';

import {
    QuestionFormWithOptionsBase,
    QuestionFormWithOptionsBaseProps,
    QuestionFormWithOptionsBaseStates
} from '../QuestionFormWithOptionsBase';
import NotifyHOC from '../../../../../../HOC/Notifications';
import { QTYPES } from '@nexxt/common/types';

/* Components used in this question form. */
import BuilderHeader from '../../../common/builderHeader';
import QuestionSettings from '../../../common/questionSettings';
import {
    DEFAULT_TEXT,
    FOLLOW_UP_TEXTS
} from '../../../../../../constants/defaultText';
import MultimediaBubble from '../../../common/MultimediaBubble';

export interface NPSProps extends QuestionFormWithOptionsBaseProps {
    // nothing special... yet!
}

export interface NPSState extends QuestionFormWithOptionsBaseStates {
    // nothing special... yet!
}
class NPS extends QuestionFormWithOptionsBase<NPSProps, NPSState> {
    constructor(p: QuestionFormWithOptionsBaseProps) {
        super(p, QTYPES.NPS);
        const question = {
            ...this.state.question,
            showFollowUp: true,
            showGenericProbe: this.props.isNewQuestion
                ? true
                : this.state.question.showGenericProbe,
            title: this.props.isNewQuestion
                ? DEFAULT_TEXT.QUESTION.NPS.TITLE
                : this.state.question.title
        };
        this.state = {
            ...this.state,
            question
        };
    }

    render() {
        const { currentProject } = this.props;
        const { question, isSettingBoxLayoutOpen } = this.state;
        const questionError =
            (this.state.showError && this.state.questionError) || {};

        return (
            <div>
                <div className="project-add--question-builder">
                    <BuilderHeader
                        toggleSettingBoxLayout={this.toggleSettingBoxLayout}
                        isSettingBoxLayoutOpen={isSettingBoxLayoutOpen}
                        showAlert={!this.props.editEnabled}
                        alertMessages={this.getWarningMessage()}
                        question={question}
                        setValue={this.setQuestion}
                        disabled={!this.props.editEnabled}
                        errorObject={this.state.questionError}
                    />
                    <div className="builder-body">
                        {(isSettingBoxLayoutOpen && (
                            <QuestionSettings
                                onClose={this.toggleSettingBoxLayout}
                                question={question}
                                questionSettings={{
                                    allowUserEdit: true
                                }}
                                setValue={this.setQuestion}
                                disabled={!this.props.editEnabled}
                            />
                        )) ||
                            null}
                        <MultimediaBubble
                            question={question}
                            languages={currentProject.languages}
                            setValue={this.setQuestion}
                            setValueWithLanguage={
                                this.NEW_setQuestionTextTranslation
                            }
                            addNewBubble={this.NEW_addNewEditor}
                            removeBubble={this.NEW_removeEditor}
                            disabled={!this.props.editEnabled}
                            defaultText={
                                DEFAULT_TEXT.QUESTION.NPS.QUESTION_TEXT
                            }
                            questionText={
                                DEFAULT_TEXT.QUESTION.NPS.QUESTION_TEXT_LABEL
                            }
                            questionError={questionError}
                            settings={{ showClose: true }}
                        />
                        {FOLLOW_UP_TEXTS.NPS.map((f, i) => {
                            return (
                                <MultimediaBubble
                                    key={`followUp-${i}`}
                                    languages={currentProject.languages}
                                    keyName={f.keyName}
                                    question={question}
                                    setValue={this.setQuestion}
                                    setValueWithLanguage={
                                        this.NEW_setQuestionTextTranslation
                                    }
                                    disableAddBubble
                                    defaultText={f.text}
                                    questionText={f.label}
                                    helperText={f.helperText}
                                    questionError={questionError}
                                    disabled={!this.props.editEnabled}
                                    settings={{ showRootReference: true }}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(
    NotifyHOC(
        connect(
            mapStateToQuestionFormBaseProps,
            mapDispatchToQuestionFormBaseProps
        )(NPS)
    )
);
